import { I8N } from "@eres/core";
import rest from "@eres/rest";
import { getSiteLocaleRootUrl, getSiteRootUrl } from "@my-dld/utils/UrlUtils";
import { RequestHeaders } from "@eres/rest/dist/Processor";
import { Configure } from "@my-dld/config";
import { configureApi } from "@my-dld/screens/MyDLD/AppConfig";
import EjariWebConfig, { UIConfig as EjariUIConfig } from "@eres/ejari-web/EjariWebConfig";
import { DetailsKV } from "@my-dld/screens/MyDLD/PropertyDetails";
import { EjariCoreConfig } from "@eres/ejari-core/constants";
import { getEjariActiveUserId, getEjariUserType, getEmiratesID, getMobileNumber, getParticipantID, isOwnerLoggedIn } from "@10x/sso";

export const AppConstants = {
	rootUrl: "/",
	rootUrlLocale: "/en"
};

export function isNextGateway( url: string ): boolean {
	if ( url?.startsWith( "https://stgapi2" ) || url?.startsWith( "https://b2c.dubailand.gov.ae" ) || url?.startsWith( "https://gateway2" )) return true;
	return false;
}

export function getConsumerId( url: string ): string | undefined {
	if ( isNextGateway( url ) ) {
		let cId = window.apiConfig2?.consumerId;
		if ( cId )
			return cId;
	}
	return window.apiConfig?.consumerId;
}

function ConsumerIdHeaderProcessor( httpMethod: string, url: string, headers: RequestHeaders, extraHeaders?: RequestHeaders ) {
	const nh: any = {};
	const cId = getConsumerId( url );
	if ( cId ) {
		nh[ "consumer-id" ] = cId;
	}
	if ( window.AppInfo && window.AppInfo.config && window.AppInfo.config.AppId ) {
		nh[ "X-App-Id" ] = window.AppInfo.config.AppId;
	}
	return {
		...headers,
		...nh,
	};

}

export function configureApp() {
	if ( window.AppInfo ) {
		I8N.setLocale( window.AppInfo.I8N.locale );
	}
	rest.addHeaderProcessor( ConsumerIdHeaderProcessor );
	AppConstants.rootUrl = getSiteRootUrl();
	AppConstants.rootUrlLocale = getSiteLocaleRootUrl();
	EjariWebConfig.rootUrl = AppConstants.rootUrl;
	EjariWebConfig.rootUrlLocale = AppConstants.rootUrlLocale;
	EjariUIConfig.DetailsKV = DetailsKV;
	EjariCoreConfig.getParticipantID = getParticipantID;
	EjariCoreConfig.getEjariActiveUserId = getEjariActiveUserId;
	EjariCoreConfig.getEjariUserType = getEjariUserType;
	EjariCoreConfig.isOwnerLoggedIn = isOwnerLoggedIn;
	EjariCoreConfig.getMobileNumber = getMobileNumber;
	EjariCoreConfig.getEmiratesId = getEmiratesID;
	Configure();
	configureApi();
}
